//import S3 from "aws-s3";
//import moment from "moment";
//import sha1 from "sha1";

export var files = {
    methods: {
        bucketConfig(envData) {
            const { generalEx, applicationEx, transactionEx } = envData;
            let result = generalEx.bucket;
            if (
                transactionEx.transaction &&
                this.notBlank(transactionEx.transaction.bucketName) &&
                transactionEx.bucket
            ) {
                result = transactionEx.bucket;
            } else if (
                applicationEx.application &&
                this.notBlank(applicationEx.application.bucketName) &&
                applicationEx.bucket
            ) {
                result = applicationEx.bucket;
            }
            return result;
        },

        dataPath(tranData) {
            let result = "";
            if (!this.emptyObject(tranData)) {
                let defData = {};
                Object.keys(tranData).forEach((key) => {
                    if (tranData[key]) {
                        defData[key] = tranData[key];
                    }
                });
                Object.keys(defData).forEach((key, index) => {
                    result +=
                        key +
                        "_" +
                        defData[key] +
                        (index < Object.keys(defData).length - 1 ? "/" : "");
                });
            }
            return result;
        },

        /*
        promiseUploadFileDirect(data) {
            const theConfig = this.bucketConfig(data.envData);
            const thePath = this.dataPath(data.tranData);

            let config = {
                bucketName: theConfig.rootName,
                dirName: thePath,
                region: theConfig.region,
                accessKeyId: theConfig.accessKey,
                secretAccessKey: theConfig.secretAccessKey,
            };

            let client = new S3(config);
            let fileName = sha1(
                moment().format() + this.getFileNameClean(data.file.name)
            );
            if (this.emptyString(data.file.type)) {
                fileName =
                    fileName + "." + this.getFileExtension(data.file.name);
            }
            return client.uploadFile(data.file, fileName);
        },
        */

        promiseUploadFileProxy(data) {
            const type = this.getFileExtension(data.file.name);

            return this.apiDoProcessFile({
                path: {
                    transactionName:
                        data.envData.transactionEx.transaction.name,
                },
                body: {
                    fieldName: data.fieldName,
                    inputData: data.tranData,
                    type: type,
                    file: data.buffer,
                    name: data.file.name,
                },
            });
        },

        promiseUploadFile(data) {
            return this.promiseUploadFileProxy(data);
        },

        getFileDirectory(fullPath) {
            const folderArray = fullPath.split("/");
            const folderClean = folderArray.split("", -1);
            return folderClean;
        },
        getFileName(fullPath) {
            const folderArray = fullPath ? fullPath.split("/") : [];
            return folderArray[folderArray.length - 1];
        },
        getFileNameClean(fullPath) {
            const fileName = this.getFileName(fullPath);
            const fileParts = fileName.split(".");
            return fileParts.slice(0, fileParts.length - 1).join("");
        },
        getFileExtension(fileName) {
            const nameArray = fileName ? fileName.split(".") : [];
            const extArray = nameArray[nameArray.length - 1];
            const extClean = extArray.split("?")[0];
            return extClean;
        },
        getFileExtensionExt(fileName) {
            let ext = this.getFileExtension(fileName);
            if (ext == "undefined") {
                const nameArray = fileName.split(".");
                const extArray = nameArray[nameArray.length - 2];
                ext = extArray;
            }
            return ext;
        },
        getFileNameNoUndefined(fileName) {
            let name = this.getFileName(fileName);
            if (this.getFileExtension(name) == "undefined") {
                name = name.replace(".undefined", "");
            }
            return name;
        },
        isFileType(fileName, extension) {
            let result = false;
            if (this.notBlank(fileName)) {
                result =
                    this.getFileExtension(fileName) == extension ||
                    this.getFileName(fileName).includes(
                        "." + extension + ".undefined"
                    );
            }
            return result;
        },
        isFilePsd(fileName) {
            return this.isFileType(fileName, "psd");
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () =>
                    resolve(
                        reader.result.replace("data:", "").replace(/^.+,/, "")
                    );
                reader.onerror = (error) => reject(error);
            });
        },
        downloadFileFromUrl(getUrl, context) {
            fetch(getUrl)
                .then((response) => response.blob())
                .then((blob) => {
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement("a");
                    const fileName = this.getFileNameNoUndefined(
                        getUrl.split("?")[0]
                    );
                    const extension = this.getFileExtension(
                        getUrl.split("?")[0]
                    );
                    const contextName = context
                        .filter((e) => e)
                        .map((e) => e.toUpperCase())
                        .join("_");
                    const title = context
                        ? contextName + "." + extension
                        : fileName;
                    link.href = url;
                    link.setAttribute("download", title);
                    document.body.appendChild(link);
                    link.click();
                });
        },
    },
};
